import { type FC } from 'react';
import styles from './DiscountPercentage.module.scss';

const DiscountPercentage: FC<{ value: number | undefined }> = ({ value }) => {
  return value ? (
    <span className={styles.discount}>{`-${Math.abs(value)} %`}</span>
  ) : null;
};

export default DiscountPercentage;
